<template>
<div>
  <div class="my-account">
    <div class="wrapper" v-if="adminid=='999999'">
      <div style="border-style:solid; border-width:1px; border-color:#a35608;padding:0.36rem 0 0.05rem 0;width:95%;margin:0 auto;border-radius:0.2rem">
            <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem" @click="showClassPicker = true">当前所在寺庙为：<span style="color:red">{{cateName}}</span></div>
            <div class="nav acea-row row-middle">
              <div class="item" @click="showClassPicker = true">
                <div class="pictrue"><img src="@assets/images/simiao.png" /></div>
                <div>寺庙切换</div>
              </div>
              <div class="item">
                <router-link :to="'/admin/order/4'" style="color:#999">
                    <div class="pictrue"><img src="@assets/images/adminqifuorder.png" /></div>
                    <div>祈福记录</div>
                </router-link>
              </div>
              <div class="item">
                <router-link :to="'/user/systemSet'" style="color:#999">
                    <div class="pictrue"><img src="@assets/images/simiao.png" /></div>
                    <div>寺庙管理</div>
                </router-link>
              </div>
              <!-- <div class="item">
                <div class="pictrue"><img src="@assets/images/sendadmin.png" /></div>
                <div>授权管理人</div>
              </div> -->
              <div class="item">
                <div class="pictrue"><img src="@assets/images/adminset.png" /></div>
                <div>寺庙系统设置</div>
              </div>
            </div>
      </div> 
    </div>

    <div class="wrapper">
      <div style="border-style:solid; border-width:1px; border-color:#a35608;padding:0.36rem 0 0.05rem 0;width:95%;margin:0 auto;border-radius:0.2rem">
            <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem">设备流量卡有效期至：<span style="color:red">{{cardDate}}</span>。请及时续费。</div>
            <div class="nav acea-row row-middle">
              <div class="item">
                <div class="pictrue"><img src="@assets/images/liuliangka.png" /></div>
                <div>流量卡充值</div>
              </div>
              <div class="item">
                <router-link :to="'/admin/order/4'" style="color:#999">
                  <div class="pictrue"><img src="@assets/images/qifuorder.png" /></div>
                  <div>祈福记录</div>
                </router-link>
              </div>
              <div class="item">
                <div class="pictrue"><img src="@assets/images/admin.png" /></div>
                <div>联系管理员</div>
              </div>
              <div class="item">
                <div class="pictrue"><img src="@assets/images/set.png" /></div>
                <div>网站设置</div>
              </div>
            </div>
      </div> 
    </div>


    <div class="wrapper"  v-for="(item, index) in deviceList" :key="index">

        <div style="border-style:solid; border-width:1px; border-color:#a35608;padding:0.36rem 0 3.5rem 0;width:95%;margin:0 auto;border-radius:0.2rem">
            <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem">当前设备：{{item.remark}}</div>
            <div class="nav acea-row row-middle">
              <div class="item" @click="operationLamp(17,null,item)">
                <div class="pictrue"><img src="@assets/images/merchant_voice.png" /></div>
                <div>调到最佳音量</div>
              </div>
              <div class="item" @click="operationLamp(11,null,item)">
                <div class="pictrue"><img src="@assets/images/lights_up.png" /></div>
                <div>全部灯亮</div>
              </div>
              <div class="item" @click="operationLamp(12,null,item)">
                <div class="pictrue"><img src="@assets/images/lights_out.png" /></div>
                <div>全部灯灭</div>
              </div>
              <div class="item" @click="operationLamp(3,2,item)">
                <div class="pictrue"><img src="@assets/images/record3.png" /></div>
                <div>模拟投币</div>
              </div>
            </div>
            <div style="height:0.2rem"></div>
            <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem">请选择要点亮的长明灯蜡烛：</div>
            <div style="height:0.2rem"></div>
            <div style="font-size:0.3rem;color:red;margin-left:0.3rem" v-if="item.isMakeLonglamp==1||item.isMakeLonglamp==2">定时任务：{{item.timeLongLamp}}</div>
            <div style="font-size:0.3rem;color:red;margin-left:0.3rem" v-if="item.isMakeLonglamp==1">您选择的以下蜡烛将于每天的 {{item.startTime}} 开始点亮，每天的 {{item.endTime}} 熄灭。</div>
            <div style="font-size:0.3rem;color:red;margin-left:0.3rem" v-if="item.isMakeLonglamp==2">您选择的以下蜡烛即将从 {{item.startTime}} 开始点亮，即将在 {{item.endTime}} 熄灭。</div>
            <div style="height:0.2rem"></div>
            <div class="nav acea-row row-middle" style="text-align:center;margin:0,auto;">
                <table style="height:100%;width:98%;margin:auto;border-radius:0.16rem;overflow:hidden;background-color:#ffffff;"  v-if="1!=item.lampType">
                  <tr style="height:0.8rem" v-for="rowCount in item.deviceRow" :key="rowCount">
                      <td v-for="columnCount in item.deviceColumn" @click="selectLamp(rowCount,columnCount,item,$event)">
                          <img v-bind:src="lazhu" style="width:0.67rem"/>
                      </td>
                  </tr>
                </table>
                <table style="height:100%;width:98%;margin:auto;border-radius:0.16rem;background-color:#ffffff;" v-if="1==item.lampType">
                  <tr style="height:0.75rem" v-for="rowCount in item.deviceRow" :key="rowCount">
                      <td v-for="columnCount in (item.deviceColumn*2)" @click="selectLampSingle(rowCount,columnCount,item,$event)">
                          <img v-bind:src="lazhusingle" style="width:0.35rem" v-if="item.deviceColumn>7" />
                          <img v-bind:src="lazhusingle" style="width:0.58rem" v-if="item.deviceColumn<=7" />
                      </td>
                  </tr>
                </table>
                <div style="height:1.2rem"></div>
                <div style="width:100%;text-align:center;margin:0,auto;margin-top:0.1rem">
                  <button type="button" @click="operationLamp(3,0,item)" style="border-style:solid; border-width:1px; border-color:#a35608;border-radius:0.16rem;height:0.75rem;width:2rem">
                    点亮长明灯
                  </button>
                  &nbsp;
                  <button type="button" @click="operationLamp(3,1,item)" style="border-style:solid; border-width:1px; border-color:#a35608;border-radius:0.16rem;height:0.75rem;width:2rem">
                    关闭长明灯
                  </button>
                  &nbsp;
                  <button type="button" @click="setTime(item)" style="border-style:solid; border-width:1px; border-color:#a35608;border-radius:0.16rem;height:0.75rem;width:2.2rem">
                    定时开关长明灯
                  </button>
                </div>
            </div>   
      </div>
    </div>
    <div class="center" v-if="timingWin==1">
        <div class="centerdiv">当前位置：{{currSite}}</div>
        <div class="centerdiv">
            定时类型：
            <button @click="switchTypeCur(1)" :class="[switchType ? 'selectdiv' : '']">每日定时</button> &nbsp;&nbsp;
            <button @click="switchTypeCur(2)" :class="[switchType ? '' : 'selectdiv']">按周期定时</button>
        </div>
        <div class="centerdiv" v-if="switchType">请选择定时开启、关闭长明灯时间：
          <div style="margin-top:0.3rem;">
            开始时间：
            <vue-timepicker v-model="startTime" :minute-interval="5" placeholder="开始时间" close-on-complete input-width="6em">
            </vue-timepicker>
            </div>
          <div style="margin-top:0.1rem;">
            结束时间：
            <vue-timepicker v-model="endTime" :minute-interval="5" placeholder="结束时间" close-on-complete input-width="6em">
            </vue-timepicker>
          </div>
        </div>

        <div class="centerdiv" v-if="!switchType">请选择定时开启、关闭长明灯时间：
          <div style="margin-top:0.3rem;height:1rem;">
            <div style="display:inline-block;text-align: center;vertical-align:middle;height:1rem; margin: 0 auto;">开始时间：</div>
            <div  @click="showTime" style="display:inline-block;text-align:center;border-style:solid; border-width:1px; border-color:#f8e006;border-radius:0.16rem;height:0.75rem;width:3rem">
                {{startTime1}}
                <vue-hash-calendar
                  :visible.sync="isShowCalendar"
                  model="dialog"
                  format="YY-MM-DD hh:mm"
                  @confirm="changeTime"
                  :disabled-date="disabledDate"
                ></vue-hash-calendar>
            </div>
          </div>
          <div style="margin-top:0.1rem;">
            <div style="display:inline-block;text-align:center;vertical-align:middle;height:1rem; margin: 0 auto;">结束时间：</div>
            <div @click="showTime1" style="display:inline-block;text-align:center;border-style:solid; border-width:1px; border-color:#f8e006;border-radius:0.16rem;height:0.75rem;width:3rem">
                {{endTime1}}
                <vue-hash-calendar
                  :visible.sync="isShowCalendar1"
                  model="dialog"
                  format="YY-MM-DD hh:mm"
                  @confirm="changeTime1"
                  :disabled-date="disabledDate"
                ></vue-hash-calendar>
            </div>
          </div>
        </div>

        <div class="centerdiv">
            执行状态：
            <button @click="switchStatus(1)"  :class="[switchStatusFlag ? 'selectdiv' : '']">开始执行</button> &nbsp;
            <button @click="switchStatus(2)"  :class="[switchStatusFlag ? '' : 'selectdiv']">停止执行</button>
        </div>
        <div class="buttonDiv">
            <div @click="setTimecancel()" class="buttonStyle">
              取消
            </div>
            <div  @click="deviceTiming()" class="buttonStyle">
              确定
            </div>
        </div>
        
    </div>

    
  </div>

<!-- <van-picker
show-toolbar
:columns="columns"
value-key="text"
/> -->
 <van-popup v-model="showClassPicker" position="bottom">
      <van-picker
      title="请选择要查看的寺庙"
      show-toolbar
      :columns="columns"
      @confirm="onClassConfirm"
      @cancel="showClassPicker = false"
      />
 </van-popup>



</div>
</template>
<script>
import Recommend from "@components/Recommend";
// import { getBalance } from "../../api/user";
import { queryDevice,device,deviceTiming } from "../../api/lamp";
import lazhu from '@assets/images/lazhu1.png'
import lazhusingle from '@assets/images/lazhusingle.png'

// import initData from '@/mixins/crud'
import VueTimepicker from 'vue2-timepicker'
// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'

import Datepicker from 'vuejs-datepicker';
import {zh} from 'vuejs-datepicker/dist/locale'


import { Picker } from 'vant'

import { getCategoryAll } from "@api/store";
import { mapGetters } from "vuex";

export default {
  name: "UserAccount",
  components: {
    Recommend,
    VueTimepicker,
    Datepicker,
    vanPicker: Picker,
  },
  props: {},
  data: function() {
//  const customFieldName = {
//       text: 'cateName',
//       values: 'id',
//     };
    return {
      adminid:0,
      cateName: "",
      cateId:0,
      columns:[],
      cardDate:"",

      showClassPicker:false,
      startTime:"",
      endTime:"",
      switchStatusFlag:true,
      switchType:true,
      isShowCalendar:false,//日历组件
      isShowCalendar1:false,//日历组件
      zh:zh,
      timingWin:0,
      currSite:"",
      deviceName:"",
      // lampNumLampSite:"",
      lazhu:lazhu,
      lazhusingle:lazhusingle,
      deviceList:[],
      now_money: 0,
      orderStatusSum: 0,
      recharge: 0,
      activity: {
        is_bargin: false,
        is_pink: false,
        is_seckill: false
      },
      lampSiteInfoList:[],
      deviceMap:new Map(),
    };
  },
  computed: mapGetters(["userInfo","isLogin"]),
  mounted: function() {
    //this.queryDevice();
    this.getUserInfo();
    
  },
  methods: {
    checkIsLogin(){
      const isLogin = this.isLogin;
      if (!isLogin) return toLogin();
    },
    getUserInfo(){
          this.$store.dispatch("USERINFO").then((res) => {
                this.adminid=res.adminid
               
                this.cateId=res.adminid
                this.getCategoryAll();
                 //alert(this.cateId)
          });
    },
    getCategoryAll(){
        let that = this;
        getCategoryAll().then(
          res => {
            if(res.data!=null){
                if(res.data.length==1){
                this.cardDate = res.data[0].cardDate
                }else{
                    res.data.forEach((item,index) => { // res.data中有值
                        this.columns.push({
                          text: item.cateName,
                          value:item.id,
                          cardDate:item.cardDate
                        })
                    })
                }
                
                if(this.cateId==0){
                   alert("无权限，非管理人员请勿非法操作")
                }else {
                    this.queryDevice();
                }
                
            }
          },
          err => {
            that.$dialog.message(err.msg);
          }
        );
    },
    onClassConfirm(v) {
      this.cateName=v.text;
      this.cateId=v.value;
      this.cardDate = v.cardDate;
      this.showClassPicker = false;
      this.queryDevice();
    },

    setTime(item){
        if(!this.deviceMap.get(item.deviceName)){
            alert("请先选择要定时开关的长明灯")
            return ;
        }
        this.timingWin=1;
        this.currSite=item.remark;
        this.deviceName=item.deviceName
    },
    setTimecancel(){
        this.timingWin=0;
    },
    operationLamp(cmd,statusLamp,item){
        var tip="";
        if(cmd==17){
          tip="您确定要调整到最佳声音?"
        }else if(cmd==11){
          tip="您确定要点亮全部蜡烛灯?"
        }else if(cmd==12){
          tip="您确定要熄灭全部蜡烛灯?"
        }else if(cmd==3){
          if(statusLamp==2){
              //模拟投币
              tip="您确定要进行模拟投币吗?"
          }else{
              if(!this.deviceMap.get(item.deviceName)){
                  this.$dialog.message("请选择要操作的长明灯");
                  return ;
              }
              if(statusLamp==0){
                  //点亮
                  tip="您确定要点亮所选中的长明亮吗?"
              }else if(statusLamp==1){
                  //熄灭
                  tip="您确定要熄灭所选中的长明亮吗?"
              }else{
                this.$dialog.message("非法操作");
                return ;
              }
          }
        }
        this.$dialog.confirm({
          mes: tip,
          opts: () => {
            this.device(cmd,statusLamp,item);
          }
        });
    },
    device(cmd,statusLamp,item){
        let that = this;

        let lampSiteInfoList=[];
        if(this.deviceMap.get(item.deviceName)){
            lampSiteInfoList=this.deviceMap.get(item.deviceName);
        }
        console.log("this.deviceMap.get(item.deviceName)=============="+this.deviceMap.get(item.deviceName))
                
        let data = {
            cmd: cmd,
            deviceName:item.deviceName,
            lampNumLampSite:lampSiteInfoList.join(","),
            statusLamp:statusLamp
        };
        device(data).then(
          res => {
            that.$dialog.message("操作成功");
          },
          err => {
            that.$dialog.message(err.msg);
          }
        );
    },
    
    // selectLamp(rowCount,columnCount,item,event){
    //     //倒序确定编号
    //     var selectLamp=((item.deviceRow-rowCount)*item.deviceColumn)+columnCount;

    //     var lampNumLampSite="";
    //     var lampNumLampSiteAll = this.deviceMap.get(item.deviceName)
    //     if(!lampNumLampSiteAll){
    //         lampNumLampSiteAll="";
    //     }
    //     if(event.currentTarget.className=='checked'){
    //         event.currentTarget.className = ""
    //         if(lampNumLampSiteAll.indexOf(selectLamp)!=-1){
    //           lampNumLampSite=lampNumLampSiteAll.replace(","+selectLamp,'');
    //         }
    //     }else{
    //         event.currentTarget.className = "checked"
    //         lampNumLampSite=lampNumLampSiteAll+","+selectLamp;
    //     }

    //     this.deviceMap.set(item.deviceName,lampNumLampSite);

    // },
    selectLamp(rowCount,columnCount,item,event){
        //倒序确定编号
        let selectLamp=((item.deviceRow-rowCount)*item.deviceColumn)+columnCount;
        let lampSiteInfoList=[];
        if(this.deviceMap.get(item.deviceName)){
            lampSiteInfoList=this.deviceMap.get(item.deviceName);
        }
        for(let i = 0;i<lampSiteInfoList.length;i++){
            if(lampSiteInfoList[i]==selectLamp){
                //说明数组中已经存在该编号，必须取消
                event.currentTarget.className = ""
                lampSiteInfoList.splice(i, 1);
                return ;
            }
        }
        
        lampSiteInfoList.push(selectLamp);
        event.currentTarget.className = "checked"
        this.deviceMap.set(item.deviceName,lampSiteInfoList);
    },
    selectLampSingle(rowCount,columnCount,item,event){
        var deviceColumn = item.deviceColumn*2;//总列数
          
        //倒序确定编号
        //let selectLamp1 =((item.deviceRow-rowCount)*item.deviceColumn)+columnCount;
        //当前选中蜡烛编号
        let selectLamp2 = deviceColumn-(columnCount-1);
        //另一根蜡烛编号
        let selectLamp1;
        if(columnCount>item.deviceColumn){
            selectLamp1=item.deviceColumn - (selectLamp2-1);
        }else{
            selectLamp1=item.deviceColumn - (columnCount-1);
        }
        let selectLamp =((item.deviceRow-rowCount)*item.deviceColumn)+selectLamp1;
        
        let lampSiteInfoList=[];
        if(this.deviceMap.get(item.deviceName)){
            lampSiteInfoList=this.deviceMap.get(item.deviceName);
        }
        for(let i = 0;i<lampSiteInfoList.length;i++){
            if(lampSiteInfoList[i]==selectLamp){
                //说明数组中已经存在该编号，必须取消
                event.currentTarget.className = ""
                for(let i=0;i<event.currentTarget.parentElement.childNodes.length;i++){
                  if((i+1)==selectLamp2){
                      event.currentTarget.parentElement.childNodes[i].className = ""
                  }
                }
                lampSiteInfoList.splice(i, 1);
                // this.deviceMap.set(item.deviceName,lampSiteInfoList);
                // console.log("this.deviceMap.get(item.deviceName)=============="+this.deviceMap.get(item.deviceName))
                return ;
            }
        }

        //选中
        event.currentTarget.className = "checked"
        for(let i=0;i<event.currentTarget.parentElement.childNodes.length;i++){
          if((i+1)==selectLamp2){
              event.currentTarget.parentElement.childNodes[i].className = "checked"
          }
        }
        
        lampSiteInfoList.push(selectLamp);
        this.deviceMap.set(item.deviceName,lampSiteInfoList);

        // console.log("this.deviceMap.get(item.deviceName)=============="+this.deviceMap.get(item.deviceName))
    },
    // initLamp(){
    //    event.currentTarget.className = ""
    //     for(let i=0;i<event.currentTarget.parentElement.childNodes.length;i++){
    //       if((i+1)==selectLamp2){
    //           event.currentTarget.parentElement.childNodes[i].className = ""
    //       }
    //     }
        
    // },
    queryDevice: function() {
      this.checkIsLogin();
      let that = this;
      queryDevice(this.cateId).then(
        res => {
          this.deviceList=res.data;
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    },

    showTime(){
      this.isShowCalendar=true;
    },
    showTime1(){
      this.isShowCalendar1=true;
    },

    /**
     * 改变时间
     * */
    changeTime(data){
      this.startTime1 = data;//改变页面展示的时间
    },
    changeTime1(data){
      this.endTime1 = data;//改变页面展示的时间
    },
 
 
    /**
     * 禁用今天以后的日期
     * */
    disabledDate(date) {
      let timestamp = date.getTime();

      var curDate = new Date();
      var preDate = new Date(curDate.getTime() - 24*60*60*1000); //前一天

      if (timestamp < preDate.getTime()) {
        return true
      }
 
      return false
    },
    switchTypeCur(type){
      if(type==1){
        this.switchType=true
      }else {
        this.switchType=false
      }
    },
    switchStatus(type){
      if(type==1){
        this.switchStatusFlag=true
      }else {
        this.switchStatusFlag=false
      }
    },
    deviceTiming(){
        let that = this;

        var sTime="";
        var eTime="";
        var isMakeLonglamp="";
        if(this.switchType){
          //每日定时
          if(!this.startTime){
              alert("请选择开始时间");
              return ;
          }
          if(!this.endTime){
              alert("请选择结束时间");
              return ;
          }
          

          sTime="2020-02-02 "+this.startTime+":00";
          eTime="2020-02-02 "+this.endTime+":00";
          isMakeLonglamp="1";
        }else{
          //周期定时
          if(!this.startTime1){
              alert("请选择开始时间");
              return ;
          }
          if(!this.endTime1){
              alert("请选择结束时间");
              return ;
          }
          sTime=this.startTime1+":00";
          eTime=this.endTime1+":00";
          isMakeLonglamp="2";
        }
        var taskFlag=0;
        if(this.switchStatusFlag){
            taskFlag=1
        }
        let lampSiteInfoList=this.deviceMap.get(this.deviceName)
        let data = {
            deviceName:this.deviceName,
            taskFlag:taskFlag,
            isMakeLonglamp:isMakeLonglamp,
            startTime:sTime,
            endTime:eTime,
            lampNumLampSite:lampSiteInfoList.join(",")
        };
        deviceTiming(data).then(
          res => {
            this.timingWin=0;
            that.$dialog.message("设置成功！！！");
          },
          err => {
            that.$dialog.message(err.msg);
          }
        );

    }

  }
};
</script>
<style scoped>
.checked{
  background: #f78817;
 }

.center {
  width:95%; 
  height:7.5rem; 
  z-index:99; 
  top: 3rem;
  background-color:#a35608;
  position: fixed;
  left: 0;
  right: 0;
  margin:0 auto;
  border-radius:0.16rem;
}
.centerdiv {
  font-size:0.35rem;
  margin-top:0.4rem;
  margin-left:0.4rem;
  color:#f8e006;
}
.selectdiv {
  margin-left:0.2rem;
  background-color:red;
  border-radius:0.16rem;
}
.buttonStyle {
  float:left;
  text-align:center;
  line-height: 0.75rem;
  margin-right:0.5rem;
  border-style:solid;
  border-width:1px; 
  border-color:#f8e006;
  border-radius:0.16rem;
  height:0.75rem;
  width:1.2rem
}
.buttonDiv {
  font-size:0.35rem;
  margin-top:0.5rem;
  margin-left:0.4rem;
  color:#f8e006;
  float:right;
}


 </style>
